export default "__VITE_ASSET__6moJP4g3__"